import { useTranslation } from "react-i18next";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { ReportStatuses } from "../shared/enums/Result";
import clsx from "clsx";

interface Props {
  status: ReportStatuses;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: "2px",
      padding: theme.spacing(0.5, 1),
      textTransform: "uppercase",
      fontWeight: 700,
      fontSize: "0.75em",
      letterSpacing: ".3px",
    },
    NotViewed: {
      backgroundColor: theme.palette.lightBackground.main,
      color: theme.palette.lightBackground.contrastText,
    },
    Viewed: {
      backgroundColor: theme.palette.lightPink.main,
      color: theme.palette.lightPink.contrastText,
    },
    Analysed: {
      backgroundColor: theme.palette.lightBlue.main,
      color: theme.palette.lightBlue.contrastText,
    },
    Generated: {
      backgroundColor: theme.palette.lightGreen.main,
      color: theme.palette.lightGreen.contrastText,
    },
  }),
);

export default function ReportStatusChip(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return <span className={clsx(classes.root, classes[props.status])}>{t(`results.${props.status}`)}</span>;
}
